import PlaneAction from "./PlaneAction.js";
import {turn} from "../planeSlice.js";
import {addHeading, getDistance, getHeading, headingDiff} from "../../assets/virtual-flyout/nav-calc.js";

export default class FlyDirect extends PlaneAction {
    constructor(planeId, waypoint) {
        super(planeId);
        this.waypoint = waypoint;
        this.lastDistanceChecked = null;
    }

    logAction() {
        this.log(`Flying direct to ${this.waypoint.code}`);
    }

    execute() {
        const planeState = this.getState();
        const currentCoordinates = planeState.coordinates;
        const targetCoordinates = this.waypoint;
        const heading = getHeading(currentCoordinates, targetCoordinates);
        this.lastDistanceChecked = getDistance(currentCoordinates, targetCoordinates);

        this.logAction();
        this.dispatch(turn({heading}));
    }

    isComplete() {
        const planeState = this.getState();
        const trackToWp = getHeading(planeState.coordinates, this.waypoint);
        const currentTrack = planeState.track;
        const diff = headingDiff(currentTrack, trackToWp);
        if (Math.abs(diff) > 1) {
            const updatedHeading = addHeading(planeState.heading, diff);
            this.dispatch(turn({heading: updatedHeading}));
        }
        const distanceToWp = getDistance(planeState.coordinates, this.waypoint);
        const distanceChange = distanceToWp - this.lastDistanceChecked;
        this.lastDistanceChecked = distanceToWp;
        return distanceToWp < 0.5 || (distanceToWp < 5 && distanceChange > 0);
    }
}
